import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { setReturnsListType } from '../returnStatus/actions';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { H1, Button } from '../../components';

import { history } from '../../util/';

import { ALL_RETURNS } from '../returnStatus/constants';

export const OrderReturnsSubmittedBar = ({ setReturnsListType }) => {
  const onButtonClick = async e => {
    e.preventDefault();
    await setReturnsListType(ALL_RETURNS);
    history.push('/orders/returns');
  };

  return (
    <div
      className={classnames(
        'orderReturnsSubmittedBar',
        'prl3-sm pt4-sm pb4-sm prl10-md flex-container column text-color-primary-light bg-black u-full-width'
      )}
    >
      <div className='orderReturnsSubmittedBar__header mb5-sm mb0-md pr7-md flex-container column start'>
        <H1 className='mb1-sm' style={{ color: 'white' }}>
          <TranslatedCopy id='orderreturns.returnSubmitted' />
        </H1>
        <p className='u-full-width' style={{ color: 'white' }}>
          <TranslatedCopy id='orderreturns.returnSubmitted.copy' />
        </p>
      </div>
      <div className='orderReturnsSubmittedBar__nav u-full-width'>
        <Button
          className={classnames(
            'orderReturnsSubmittedBar__nav_button ncss-btn-primary-light',
            'u-full-width prl12-sm pt3-sm pb3-sm text-color-primary-dark'
          )}
          data-desc='orderReturnsSubmittedBar__nav_button'
          secondary
          onClick={onButtonClick}
        >
          <TranslatedCopy id='orderreturns.viewAllReturns' />
        </Button>
      </div>
    </div>
  );
};

OrderReturnsSubmittedBar.propTypes = {
  setReturnsListType: PropTypes.func.isRequired
};

const connector = connect(() => ({}), {
  setReturnsListType
});

export default connector(OrderReturnsSubmittedBar);
